import { AbstractCoroutine2jzyhqo91sb0o as AbstractCoroutine } from '../AbstractCoroutine.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { JobCancellationException2g3wpni5v5fkt as JobCancellationException } from '../Exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  close$default2suggcywjwe8g as close$default,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
  SendChannel38sllbxw662ws as SendChannel,
} from './Channel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelCoroutineClass;
function ChannelCoroutine() {
  if (ChannelCoroutineClass === VOID) {
    class $ extends AbstractCoroutine() {
      constructor(parentContext, _channel, initParentJob, active) {
        super(parentContext, initParentJob, active);
        this.x1c_1 = _channel;
      }
      gy(cause) {
        if (this.tx())
          return Unit_instance;
        var tmp;
        if (cause == null) {
          // Inline function 'kotlinx.coroutines.JobSupport.defaultCancellationException' call
          tmp = JobCancellationException().v15(null == null ? this.ax() : null, null, this);
        } else {
          tmp = cause;
        }
        this.iy(tmp);
      }
      k1c(cause, $super) {
        return this.hy(cause, ($super == null ? true : $super instanceof ChannelCoroutine()) ? $super : THROW_CCE());
      }
      iy(cause) {
        var exception = this.yx(cause);
        this.x1c_1.gy(exception);
        this.ly(exception);
      }
      p1b() {
        return this.x1c_1.p1b();
      }
      *w1b(element, $completion) {
        yield* this.x1c_1.w1b(element, $completion);
        return Unit_instance;
      }
      x1b(element) {
        return this.x1c_1.x1b(element);
      }
      g1c(cause) {
        return this.x1c_1.g1c(cause);
      }
      l1c(handler) {
        this.x1c_1.l1c(handler);
      }
      *z1b($completion) {
        return yield* this.x1c_1.z1b($completion);
      }
      p1() {
        return this.x1c_1.p1();
      }
    }
    protoOf($).i1c = close$default;
    initMetadataForClass($, 'ChannelCoroutine', VOID, VOID, [ReceiveChannel(), SendChannel()], [1, 0]);
    ChannelCoroutineClass = $;
  }
  return ChannelCoroutineClass;
}
//region block: exports
export {
  ChannelCoroutine as ChannelCoroutine12l2gxei4u780,
};
//endregion

//# sourceMappingURL=ChannelCoroutine.mjs.map
